<mat-form-field class="search">
  <input type="text"
    matInput
    placeholder="{{placeHolderText}}"
    (ngModelChange)="filterChanged($event)"
    [(ngModel)]="filter" />
  @if (!filter) {
    <mat-icon matSuffix>search</mat-icon>
  }
  @if (filter && filter.length > 0) {
    <mat-icon matSuffix tabindex="0" role="button" (click)="clearFilter()" (keydown.enter)="clearFilter()" (keydown.space)="clearFilter(); $event.preventDefault()">clear</mat-icon>
  }
</mat-form-field>